import React, {useEffect} from 'react';
import {useFormikContext} from 'formik';
import {TechnologicalMapInput} from '@me-team/host/main/graphql/types';

const UpdateRecoveryTechMapEffects: React.FC<{ pickedCategoryId: number | null }> = ({ pickedCategoryId }) => {
  const { setFieldValue } = useFormikContext<TechnologicalMapInput>();

  useEffect(() => {
    if (pickedCategoryId !== null) {
      setFieldValue("categoryId", pickedCategoryId);
    }
  }, [pickedCategoryId, setFieldValue]);

  return null;
};

export default UpdateRecoveryTechMapEffects;
